export const share = {
  name: "share",
  state: {
    //国家
    country: [],
    //城市
    city: [],
    // 区域/县/市
    area: [],
    // 订单来源，一级类目
    primaryCategories: [],
    // 订单来源，二级类目
    secondCategories: [],
    // 贸易来源
    tradeSource: [],
    // 贸易状态
    tradingStatus: [],
    // 供应商
    supplier: [],
    // 商品分类
    goodsCategroy: [],
    // 订单状态
    orderStatus: [],
    // 订单标签
    orderTag: []
  },
  reducers: {
    // 更新国家数据
    updateCountry(state, data) {
      return { ...state, country: data };
    },
    updateCity(state, data) {
      return { ...state, city: data };
    },
    updateArea(state, data) {
      return { ...state, area: data };
    },
    // 重置城市数据
    resetCity(state) {
      return {
        ...state,
        city: [],
        area: []
      };
    },
    // 重置区域数据
    resetArea(state) {
      return {
        ...state,
        area: []
      };
    },
    // 更新订单来源 一级目录
    updatePriarmyCategories(state, data) {
      return { ...state, primaryCategories: data };
    },
    // 更新 二级类别
    updateSecondCategories(state, data) {
      return { ...state, secondCategories: data };
    },
    // 重置订单来源二级类别数据
    resetSecondCategories(state) {
      return {
        ...state,
        secondCategories: []
      };
    },
    // 更新贸易来源
    updateTradeSource(state, data) {
      return { ...state, tradeSource: data };
    },
    // 更新贸易状态
    updateTradingStatus(state, data) {
      return { ...state, tradingStatus: data };
    },
    // 重置交易状态二级类目数据
    resetTradingStatus(state) {
      return {
        ...state,
        tradingStatus: []
      };
    },
    // 更新选择器数据源
    updateSelectorSource(state, data) {
      // console.warn("test", data);
      // console.info("test2222222222222", data);
      // console.log("test2222222222222", data);
      state[data.name] = data.data;
      return {
        ...state
      };
    },
    // 更新订单状态数据
    updateOrdreStatus(state, data) {
      state["orderStatus"] = data;
      return {
        ...state
      };
    },
    // 更新订单标签数据
    updateOrdreTag(state, data) {
      state["orderTag"] = data;
      return {
        ...state
      };
    }
  }
};
